import { render, staticRenderFns } from "./productSetting.vue?vue&type=template&id=14b69404&lang=pug"
import script from "./productSetting.vue?vue&type=script&lang=js"
export * from "./productSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports